// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sIEJ2","colMin":"styles_colMin__2yK8m"};